import { render, staticRenderFns } from "./homepageMainCarousel.vue?vue&type=template&id=1fc01ed8&scoped=true&"
import script from "./homepageMainCarousel.vue?vue&type=script&lang=js&"
export * from "./homepageMainCarousel.vue?vue&type=script&lang=js&"
import style0 from "./homepageMainCarousel.vue?vue&type=style&index=0&id=1fc01ed8&scoped=true&lang=css&"
import style1 from "./homepageMainCarousel.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc01ed8",
  null
  
)

export default component.exports